import {qspost} from '@/plugins/axios'

/*
 * 居民信息列表
 * @constructor jack
 * */
export const juMinList = (searchName, searchPhone,searchHuJiDi,searchIdCard,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchSex,searchHuKouXingZhi,searchHuZhuGuanXi,searchShengRiStatus,page,pageSize) => qspost('/Index/Jumin/juMinList', {searchName, searchPhone,searchHuJiDi,searchIdCard,searchXiangMuId,searchSheQuId,searchLouId,searchMenId,searchHuId,searchSex,searchHuKouXingZhi,searchHuZhuGuanXi,searchShengRiStatus,page,pageSize})



export const setOld =(id)=>qspost('/Index/Jumin/setOldStatus', {id})




/*
 * 添加/修改 居民信息
 * @constructor jack
 * */
export const juMinAdd = (xiangMuId,xiaoQuId,louId,menId,huId,name,sex,minZu,idCard,phone,status,guanXi,huKouXingZhi,huJiDi,beizhu,health,tags,id) => qspost('/Index/Jumin/juMinAdd', {xiangMuId,xiaoQuId,louId,menId,huId,name,sex,minZu,idCard,phone,status,guanXi,huKouXingZhi,huJiDi,beizhu,health,tags,id})

/*
 * 居民信息详情
 * @constructor jack
 * */
export const juMinShow = (id) => qspost('/Index/Jumin/juMinShow', {id})

/*
 * 删除 居民信息
 * @constructor jack
 * */
export const juMinDel = (id) => qspost('/Index/Jumin/juMinDel', {id})

/*
* 获取导入时需要选择的项目 小区 楼门户
* */

export const getLouMenListByYuanGong = () => qspost('/Index/Importexcel/getLouMenListByYuanGong', {})

/*
 * 添加报修信息
 * @constructor jack
 * */
export const addBaoXiu = (xiangMuId,xiaoQuId,louId,menId,huId,name,phone,type,baoXiuContent,id) => qspost('/Index/Xinxuqiu/addBaoXiu', {xiangMuId,xiaoQuId,louId,menId,huId,name,phone,type,baoXiuContent,id})
